module.exports = __webpack_public_path__ + "img/nft-games.46c1149d.png";